/**
 * Payments API endpoints - subscription status, policy, checkout
 */
import { fetchApi } from './apiBase';

export interface SubscriptionStatus {
  tier: 'free' | 'plus';
  expires: string | null;
  is_active: boolean;
  // S1/S5: where the active entitlement comes from, for provider-aware management.
  providers?: string[];
  primary_provider?: string | null;
  subscription_source?: 'stripe' | 'apple_iap' | 'google_play' | null;
  subscription_product_id?: string | null;
  free_access_enabled: boolean;
}

export interface TierPolicy {
  tier: 'free' | 'plus';
  full_access: boolean;
  free_access_enabled: boolean;
  allowed_models: string[];
  chat_limit: number | null;
  plan_limit: number | null;
  plan_count: number;
}

export async function getSubscriptionStatus(): Promise<SubscriptionStatus> {
  return fetchApi<SubscriptionStatus>('/api/v1/payments/status/');
}

export async function getPolicy(): Promise<TierPolicy> {
  return fetchApi<TierPolicy>('/api/v1/payments/policy/');
}

export async function createCheckout(plan: 'monthly' | 'annual' = 'monthly'): Promise<{ checkout_url: string }> {
  return fetchApi<{ checkout_url: string }>('/api/v1/payments/create-checkout/', {
    method: 'POST',
    body: JSON.stringify({ plan }),
  });
}

export async function createPortalSession(): Promise<{ portal_url: string }> {
  return fetchApi<{ portal_url: string }>('/api/v1/payments/portal/', {
    method: 'POST',
  });
}
